export default "__VITE_ASSET__RghfgUGq__"